<template>
        <div>
        <!-- Loading Message -->
        <p v-if="!dataLoaded">Loading</p>
        
        <!-- Loaded Data -->
        <div v-if="dataLoaded">
            <button @click="editMode = !editMode">{{editMode ? "Cancel":"Edit"}}</button>
        
            <!-- Edit View -->
            <form v-if="editMode" v-on:submit.prevent>
                <div class="row">
                    <div class="column">
                        <h3>Locker Info</h3>
                        <label>ID</label><input type="number" v-model="combination.id" disabled>
                        <label>Name</label><input type="text" v-model="combination.name">
                        <label>Price</label><input type="number" step="0.01" v-model="combination.totalPrice">
                        <label>Num Lockers</label><input type="number" v-model="combination.totalLockers">
                    </div>
                    <div class="column">
                        <h3>Dimensions</h3>
                        <label>Height (mm)</label><input type="number" v-model="combination.totalHeight">
                        <label>Width (mm)</label><input type="number" v-model="combination.totalWidth">
                        <label>Depth (mm)</label><input type="number" v-model="combination.totalDepth">
                        <label>Is A Standard Config? </label><input type="checkbox" v-model="combination.standardConfig">
                        <label>Outdoor Locker? </label><input type="checkbox" v-model="combination.isOutdoor">
                    </div>
                </div>
                
                <!-- Image Management -->
                <div class="row">
                    <div class="column">
                        <h3>Locker Image</h3>
                        <img v-if="combination.euroImage" :src="'data:image/jpeg;base64,' + combination.euroImage">
                        <p v-else>No image uploaded</p>
                        <label>Replace Image</label><input type="file" @change="handleEuroImageUpload" accept="image/png,image/jpeg,image/jpg,image/gif,image/tiff,image/bmp">
                        <label>Delete Image</label><input type="checkbox" v-model="deleteEuroImage">
                    </div>
                    <div class="column">
                        <h3>Locker Dimensions</h3>
                        <img v-if="combination.euroPlan" :src="'data:image/png;base64,' + combination.euroPlan">
                        <p v-else>No dimensions uploaded</p>
                        <label>Replace Dimensions</label><input type="file" @change="handleEuroPlanUpload" accept="image/png,image/jpeg,image/jpg,image/gif,image/tiff,image/bmp">
                        <label>Delete Dimensions</label><input type="checkbox" v-model="deleteEuroPlan">
                    </div>
                </div>
                <button @click="updateCombination">Save</button>
            </form>

            <!-- Regular View -->
            <div v-if="!editMode">
                <!-- Module Details -->
                <div class="row">
                    <div class="column">
                        <h3>Details</h3>
                        <p><b>ID </b> {{ this.combination.id }}</p>
                        <p><b>Name </b> {{ this.combination.name }}</p>
                        <p><b>Price </b> ${{ Number(this.combination.totalPrice).toFixed(2) }}</p>
                        <p><b>Number of Lockers </b> {{ this.combination.totalLockers }}</p>
                    </div>
                    <div class="column">
                        <h3>Summary</h3>
                        <p><b>Height</b> {{ this.combination.totalHeight }}mm</p>
                        <p><b>Width</b> {{ this.combination.totalWidth }}mm</p>
                        <p><b>Depth</b> {{ this.combination.totalDepth }}mm</p>
                        <p><b>Standard Config? </b>{{ this.combination.standardConfig ? 'Yes' : 'Project Specific'}}</p>
                        <p><b>Outdoor Locker? </b>{{ this.combination.isOutdoor ? 'Yes' : 'No'}}</p>
                    </div>
                </div>
                
                <!-- Image Display -->
                <div class="row" v-if="combination.euroImage || combination.euroPlan">
                    <div class="column" v-if="combination.euroImage">
                        <h3>Locker Image</h3>
                        <img :src="'data:image/jpeg;base64,' + combination.euroImage">
                    </div>
                    <div class="column" v-if="combination.euroPlan">
                        <h3>Locker Dimensions</h3>
                        <img :src="'data:image/png;base64,' + combination.euroPlan">
                    </div>
                </div>
            </div>
        </div><!-- DataLoaded -->
    </div>
</template>

<script>
    import {CallApi, fileToB64, isJimpSupportedMimeType} from '../Utilities.js'
    export default {
        name: 'CombinationDetail',
        watch: {
            '$route': 'fetchData'
        },
        data: function() {
            return {
                editMode: false,
                dataLoaded: false,
                combination: {},
                deleteEuroImage: false,
                deleteEuroPlan: false,
                newEuroImage: null,
                newEuroPlan: null
            }
        },
        methods: {
            fetchData: async function() {
                this.combination  = (await CallApi('GET', `/combinations/${this.$route.params.id}`)).combination
                this.dataLoaded = true
                this.editMode = false
            },
            handleEuroImageUpload: async function(event) {
                const file = event.target.files[0]
                if (file) {
                    if (!isJimpSupportedMimeType(file)) {
                        alert('Invalid file type. Please upload an image (jpg, png, gif, tiff, bmp)');
                        event.target.value = ''
                        return
                    }

                    this.newEuroImage = await fileToB64(file)
                }
            },
            handleEuroPlanUpload: async function(event) {
                const file = event.target.files[0]
                if (file) {
                    if (!isJimpSupportedMimeType(file)) {
                        alert('Invalid file type. Please upload an image (jpg, png, gif, tiff, bmp)');
                        event.target.value = ''
                        return
                    }
                    this.newEuroPlan = await fileToB64(file)
                }
            },
            updateCombination: async function() {
                const updateData = {...this.combination}
                
                // Add image data and delete flags
                if (this.deleteEuroImage) updateData.deleteEuroImage = true
                if (this.deleteEuroPlan) updateData.deleteEuroPlan = true
                if (this.newEuroImage) updateData.euroImage = this.newEuroImage
                if (this.newEuroPlan) updateData.euroPlan = this.newEuroPlan
                
                // Post to Server
                await CallApi('POST', `/combinations/${this.combination.id}`, updateData)

                // Reset flags and new images
                this.deleteEuroImage = false
                this.deleteEuroPlan = false
                this.newEuroImage = null
                this.newEuroPlan = null
                
                // Retrieve Updated Data
                this.fetchData()
            }
        },
        mounted() { this.fetchData() }
    }
</script>